import { useMediaQuery } from "@mantine/hooks";

const MOBILE_BREAKPOINT = "(max-width: 768px)";

export function useIsMobile(): boolean {
	return useMediaQuery(MOBILE_BREAKPOINT) ?? false;
}
